export default (state = "", action) => {
  switch (action.type) {
    case "SAVE_TOURSTEPS":
      return action.payload;
    case "REMOVE_TOURSTEPS":
      return [];
    default:
      return state;
  }
};
